import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../component/colors';
import { pxToRem } from '../../utils/pxToRem';

type ILinkComponent = {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
};
export const LinkComponent: FC<ILinkComponent> = ({
  icon,
  title,
  description,
  onClick
}) => {
  return (
    <Card onClick={onClick}>
      <LinkImage src={icon} />
      <LinkDetailContainer>
        <LinkTitle>{title}</LinkTitle>
        <LinkDescription>{description}</LinkDescription>
      </LinkDetailContainer>
    </Card>
  );
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 25px 0;
  /* flex: 1; */
`;
export const LinkContainer = styled(Container)`
  flex: unset;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
`;
const LinkTitle = styled.p`
  font-size: ${pxToRem(22)};
  font-style: normal;
  font-weight: 800;
  line-height: ${pxToRem(30)};
  font-family: Nunito;
  letter-spacing: 0em;
  text-align: left;
`;
const LinkDescription = styled(LinkTitle)`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  line-height: ${pxToRem(19)};
`;
const Card = styled.button`
  padding: 24px;
  /* margin-right: 24px; */
  display: flex;
  align-items: center;
  min-width: 277px;
  justify-content: center;
  flex-direction: row;
  background-color: #ffffff;
  border: 0.5px solid #e8e8e8;
  box-sizing: border-box;
  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08),
    0px 8px 16px rgba(50, 50, 71, 0.06);
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
  &:last-child {
    /* margin-right: 0; */
  }

  &:hover {
    background-color: #ffffff09; // <Thing> when hovered
  }
`;
const LinkDetailContainer = styled.div``;
const LinkImage = styled.img`
  height: 60px;
  width: 60px;
  margin-right: 24px;
`;
export const DashboardWrapper = styled.section`
  background-color: ${colors.bgGrey};
`;
export const DashboardContainer = styled.section`
  width: 80%;
  margin: auto;
`;
export const CardGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ActivitySection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 992px) {
    display: block;
  }
`;
export const TableSection = styled.div`
  background-color: ${colors.white};
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  filter: drop-shadow(0px 8px 8px rgba(50, 50, 71, 0.08))
    drop-shadow(0px 8px 16px rgba(50, 50, 71, 0.06));
  border-radius: 8px;
  padding: 13px;
  flex: 0.733;
  @media (max-width: 900px) {
    overflow-x: auto;
    width: calc(100vw - 110px);
  }
`;
export const TableHeading = styled.h5`
  font-size: ${pxToRem(16)};
  line-height: 140%;
  color: #091e42;
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;
export const TableElement = styled.table`
  width: 100%;
  text-align: left;
`;
export const TableRule = styled.tr``;
export const TableBody = styled.tbody``;
export const TableData = styled.td`
  padding: 10px;
  text-transform: capitalize;
  border-bottom: 1px solid #ddd;
  font-size: ${pxToRem(14)};
  line-height: 150%;
  color: #091e42;
`;
export const TableHeader = styled.thead``;
export const HorizontalRule = styled.hr`
  color: 1px solid #ddd;
`;

export const TableHeadElement = styled.th`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: ${pxToRem(14)};
  line-height: 140%;
  color: #999999;
`;

export const RightAsideSection = styled.div`
  flex: 0.25;
`;
export const AgentsSection = styled.div`
  background-color: ${colors.white};
  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08),
    0px 8px 16px rgba(50, 50, 71, 0.06);
  border-radius: 8px;
  padding: 10px 20px;

  @media (max-width: 992px) {
    margin-top: 20px;
  }
`;
export const AgentsHeaderGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
`;
export const AgentsTitle = styled.h5`
  font-weight: 500;
  font-size: ${pxToRem(16)};
  color: #091e42;
`;
export const ViewMoreAgentsLink = styled(Link)`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  color: #fda800;
  text-decoration: none;
`;
export const AgentList = styled.div``;
export const AgentListGroup = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid #ece9f1;
`;
export const AgentAvatar = styled.img`
  height: 32px;
  width: 32px;
  object-fit: cover;
  border-radius: 16px;
  margin-right: 10px;
`;
export const AgentDetails = styled.div``;
export const AgentName = styled.h6`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(22)};
  margin: 0;
`;
export const AgentDesignation = styled.p`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(22)};
  color: ${colors.textLight};
  margin: 0;
`;
export const AnalyticsSection = styled.section`
  margin-top: 20px;
  background: ${colors.white};
  border-radius: 5.73529px;
  filter: drop-shadow(0px 8px 8px rgba(50, 50, 71, 0.08))
    drop-shadow(0px 8px 16px rgba(50, 50, 71, 0.06));
  padding: 10px 20px;
`;
export const AnalyticsCard = styled.div``;
export const ChartDetails = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  max-width: 387px;
`;
export const ChartGroup = styled.div``;
export const ChartImage = styled.img`
  width: 131.53px;
  height: 130.88px;
`;
export const ChartLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 7px 0;
`;
export const ChartLabelImage = styled.img`
  margin-right: 8px;
`;
export const ChartLabelText = styled.div``;
export const ChartLabelHeading = styled.p`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #11263c;
`;
export const ChartLabelFigures = styled.p`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #d0d1d2;
`;
export const AnalyticsTitle = styled.h5``;
